__turbopack_context__.v({
  "className": "caveat_6ecc5bfe-module__EEI1JW__className",
});
